import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import { ListItem } from 'material-ui';

import { getTranslationByLocale } from '../../../utils/TranslationUtils';

const Text = t(({ block, locale }) => (
  <ListItem disabled className="text" primaryText={<span dangerouslySetInnerHTML={{ __html: getTranslationByLocale(block.text, locale) }} />} />
));

export default Text;
